// Webpack Imports
import "bootstrap";
// import "instafeed.js";
import "../node_modules/bootstrap-input-spinner/src/bootstrap-input-spinner.js";

import "./main.ajaxposts.js";
import "./main.cookieconsent.js";
import "./main.woocommerce.js";

// Smooth Scroll to
export function goTo(target) {
	if ($(target).length) {
		$("html, body")
			.stop()
			.animate(
				{
					scrollTop: $(target).offset().top - 100,
				},
				800
			);
	}
	return false;
}

(function ($) {
	"use strict";

	var $window = $(window),
		$body = $("body");

	// JQuery fallback: add title attribute from placeholder
	$("input, textarea").attr("title", function () {
		return $(this).attr("placeholder");
	});

	// Custom styling for input type "number": "bootstrap-input-spinner"
	$('input[type="number"]').inputSpinner({
		buttonsClass: "",
	});

	// Focus Search if Searchform is empty
	$(".search-form").on("submit", function (e) {
		var search = $("#s");
		if (search.val().length < 1) {
			e.preventDefault();
			search.trigger("focus");
		}
	});

	// Sticky "Product summary"
	function stickyProductSummary() {
		if ($(".summary .sticky").length && $window.width() > "992") {
			// Offset: Content Summary (Right side)
			var offsetTop =
				$("#header").outerHeight() + $(".product-navigation").outerHeight();
			$(".summary .sticky").css("top", offsetTop + "px");

			// Adjust height of hero summary
			$(".hero-summary").css(
				"height",
				$window.height() +
					$(".single-product .product-images").outerHeight() +
					"px"
			);
		} else {
			$(".summary .sticky").css("top", 0);
			$(".hero-summary").css("height", "auto");
		}
	}

	stickyProductSummary();
	$window.on("resize", function () {
		stickyProductSummary();
	});

	// If scrolled down: Add "sticky" class to header
	if ($window.scrollTop() > 1) {
		//alert( 'sticky' );
		$body.addClass("header-sticky");
	}
	$window.on("scroll", function () {
		var $this = $(this),
			scrolltop = $this.scrollTop();

		// Sticky header on scroll
		if (scrolltop > 1) {
			$body.addClass("header-sticky");
		} else {
			$body.removeClass("header-sticky");
		}
	});

	// Onclick "Top"
	$(".scrolltop").on("click", function () {
		goTo("#wrapper");
	});

	// Instafeed: https://instafeedjs.com/#/?id=installation
	/*if ($("#instagram-feed").length) {
		var feed = new Instafeed({
			target: "instagram-feed",
			accessToken: $("#instagram-feed").data("token"),
		});
		feed.run();
	}*/
})(jQuery);
